import { apiClient } from './client'

export interface CodeRepository {
  id: number
  projectId: number
  name: string
  originUrl: string | null
  defaultBranch: string
  status: string
  createdAt: string
  updatedAt: string
}

export interface CodeAnalysisVersion {
  id: number
  repositoryId: number
  projectId: number
  branch: string
  commitSha: string
  uploadedBy?: string | null
  symbolTotal?: number | null
  status:
    | 'pending'
    | 'analyzing'
    | 'normalizing'
    | 'embedding_symbols'
    | 'linking_traceability'
    | 'ready'
    | 'stale'
    | 'failed'
  analyzerProvider: string
  analyzerVersion: string
  schemaVersion: string
  fileCount: number
  symbolCount: number
  relationshipCount: number
  sqlitePath: string | null
  privacyMode: string
  errorMessage: string | null
  percent?: number | null
  startedAt: string | null
  finishedAt: string | null
  createdAt: string
}

export interface CodeJobStatus {
  jobId: number
  status: string
  progress: {
    phase: string
    fileCount: number
    symbolCount: number
    symbolTotal: number | null
    percent: number | null
    uploadedBy: string | null
    relationshipCount: number
  }
  error: string | null
  startedAt: string | null
  finishedAt: string | null
}

export const codeGraphApi = {
  listRepositories(projectId: number): Promise<CodeRepository[]> {
    return apiClient.get<CodeRepository[]>(`/projects/${projectId}/repositories`)
  },
  getStatus(projectId: number): Promise<CodeAnalysisVersion & { message?: string }> {
    return apiClient.get(`/projects/${projectId}/code/status`)
  },
  listVersions(projectId: number): Promise<CodeAnalysisVersion[]> {
    return apiClient.get(`/projects/${projectId}/code/versions`)
  },
  getJob(jobId: number): Promise<CodeJobStatus> {
    return apiClient.get(`/code/jobs/${jobId}`)
  },
  deleteVersion(versionId: number): Promise<void> {
    return apiClient.delete(`/code/versions/${versionId}`)
  },
  deleteProjectGraph(
    projectId: number
  ): Promise<{ deletedRepositories: number; deletedVersions: number }> {
    return apiClient.delete(`/projects/${projectId}/code`)
  },
  deleteRepository(repositoryId: number): Promise<void> {
    return apiClient.delete(`/repositories/${repositoryId}`)
  },
}
